<template>
    <div class="paid-addon">
        <div class="paid-addon__header">
            <div>
                <text-decorator
                    :size="FontSize.xl"
                    weight="bold"
                >
                    {{ formatMoney(calculatedPrice) }}
                </text-decorator>
                <text-decorator
                    :color="'gray-500'"
                    :size="FontSize.xs"
                    weight="bold"
                >
                    / maand
                </text-decorator>
            </div>

            <div>
                <text-decorator :size="FontSize.xl">
                    {{ formatNumber(total) }}
                </text-decorator>
            </div>

            <div>
                <text-decorator :size="FontSize.lg">
                    {{ props.name }}
                </text-decorator>
            </div>
        </div>

        <div class="paid-addon__input">
            <input-group :model-value="props.modelValue" @update:model-value="$emit('update:modelValue', $event)">
                <template #input>
                    <number-input
                        :increment="props.increment"
                        :min="0"
                        hide-value
                    />
                </template>
            </input-group>
        </div>

        <button
            v-tooltip.info="props.tooltip"
            class="paid-addon__tooltip"
            type="button"
        >
            <svg-icon
                :icon="CircleInfoIcon"
                :size="IconSize.xs"
                :color="'primary'"
                is-custom-icon
            />
        </button>
    </div>
</template>

<script setup lang="ts">
    import { FontSize, IconSize, NumberInput } from '@keyvue/one-ui';
    import { computed } from 'vue';
    import { formatMoney } from '@/shared/utils/money';
    import { formatNumber } from '@/shared/utils/number';
    import CircleInfoIcon from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';

    interface Props {
        price: number
        modelValue: number
        default: number
        increment?: number
        name: string
        tooltip: string
    }

    const props = withDefaults(defineProps<Props>(), {
        increment: 1,
    });

    defineEmits<{
        (e: 'update:modelValue', value: number): void
    }>();

    const calculatedPrice = computed(() => props.price * (props.modelValue / props.increment));
    const total = computed(() => props.default + props.modelValue);
</script>

<style scoped lang="scss">
    .paid-addon {
        position: relative;
        border-radius: size(sm);
        border: 1px solid color(gray-300);

        &__header {
            display: flex;
            flex-direction: column;
            padding: size(md) size(md) size(sm);
            gap: size(xs);
        }

        &__input {
            display: flex;
            padding: 0 0 size(md) size(md);
        }

        &__tooltip {
            position: absolute;
            right: size(sm);
            top: size(sm);
            padding: 0;
            border: 0;
            background: none;
            outline: 0;
            cursor: pointer;
        }
    }
</style>
